/**
 * BL-89 — the comms localization resolver. The director / advisor / briefing
 * keep picking an i18n *key* (render-side RNG, unchanged); the display point
 * calls `commsLine(key)` to resolve it to the active locale. EN is the
 * canonical fallback so a raw key can never render — mirroring the BL-113 data
 * seam (`localizedName`). The EN corpus travels with the keys in the source
 * modules; this merges all three into the fallback table.
 */
import { t } from "../utils/i18n.ts";
import { COMMS_EN } from "./commsContent.ts";
import { COMMS_QUIP_EN } from "./commanderQuips.ts";
import { COMMS_BRIEF_EN } from "./PreRunScreenData.ts";
import { STORY_EN } from "./storyContent.ts";

const COMMS_FALLBACK: Record<string, string> = {
  ...COMMS_EN,
  ...COMMS_QUIP_EN,
  ...COMMS_BRIEF_EN,
  ...STORY_EN,
};

/** Resolve a comms i18n key to the active-locale string, falling back to the
 *  canonical EN bark (never the raw key). */
export function commsLine(key: string): string {
  return t(key, undefined, COMMS_FALLBACK[key] ?? key);
}
